import { Helmet } from 'react-helmet-async';
import TestNurturingComponent from 'app/pages/TestNurturingPage/components/TestNurturingComponent';

export default function TestNurturingPage() {
  return (
    <>
      <Helmet>
        <title>Test nurturing — Journeys &amp; templates</title>
        <meta
          name="description"
          content="Test nurturing journeys and templates before going live"
        />
      </Helmet>
      <TestNurturingComponent />
    </>
  );
}
